// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-fix-tab":"FixTab_vanlife-roadtrips-fix-tab__cGyre"};